import styled from 'styled-components';
import music from '../img/music_player.png';
import handpose from '../img/handpose.png';
// import {Link} from 'react-router-dom';
import {motion} from 'framer-motion';
import {pageAnimation,fadeAnimation,photoAnimation,lineAnimation,FrameAnimation,FrameAnimationContainer} from '../Animation';
import {UseScroll} from '../components/UseScroll.js';
import github from '../img/github.svg'

const OurWork = () => {
    const [element,controls] = UseScroll();
    const [element2,controls2] = UseScroll();
    const [element3,controls3] = UseScroll();

    return (
        <Styledwork layout = 'position' style = {{background:"#fff"}} variants = {pageAnimation} initial = "hidden" animate="show" exit = "exit" >
            <motion.div variants= {FrameAnimationContainer}>

            <StyledFrame1 variants= {FrameAnimation} ></StyledFrame1>
            <StyledFrame2 variants= {FrameAnimation}></StyledFrame2>
            <StyledFrame3 variants= {FrameAnimation}></StyledFrame3>
            <StyledFrame4 variants= {FrameAnimation}></StyledFrame4>

            </motion.div>

            



            <StyledMovie >
                <motion.h2 variants = {fadeAnimation}>Music Player App </motion.h2>
                <br></br>
                <motion.h3 variants = {fadeAnimation} style = {{color:"#353333"}}>Created using ReactJS & SCSS(Click Image for Demo) </motion.h3>
                <br></br>
                <StyledCard>
            <div className="icon">
            <a href="https://github.com/AakashAhuja30/ReactJS-Music-Player-App" target="_blank" rel="noreferrer">
                <img src={github} alt="efficient"/>
            </a>
            </div>
                  
                </StyledCard>
                <motion.div variants = {lineAnimation} className="Line"></motion.div>
                <a href="https://aakashahuja30.github.io/ReactJS-Music-Player-App/" target="_blank" rel="noreferrer">
                <motion.img variants = {photoAnimation} src={music} alt="athlete"/>
                </a>
            </StyledMovie>
            

            <StyledMovie >
                <motion.h2 variants = {fadeAnimation}>Handpose Detection Model </motion.h2>
                <br></br>
                <motion.h3 variants = {fadeAnimation} style = {{color:"#353333"}}>Created using TensorflowJS and ReactJS(Click Image for Demo) </motion.h3>
                <br></br>
                <StyledCard>
            <div className="icon">
            <a href="https://github.com/AakashAhuja30/HandposeDetection" target="_blank" rel="noreferrer">
                <img src={github} alt="efficient"/>
            </a>
                </div>
                  
        </StyledCard>

               <motion.div variants = {lineAnimation} className="Line" ref = {element} animate = {controls} initial = 'hidden'></motion.div>
 
                <a href="https://aakashahuja30.github.io/HandposeDetection/" target="_blank" rel="noreferrer">
                <motion.img variants = {photoAnimation} src={handpose} alt="athlete"/>
                </a>
            </StyledMovie>

            <StyledMovie >
                <motion.h2 variants = {fadeAnimation}>Spatial Analysis on Football Positional Data</motion.h2>
                <br></br>
                <motion.h3 variants = {fadeAnimation} style = {{color:"#353333"}}>Created using Tableau and R</motion.h3>
                <br></br>
                <StyledCard>
            <div className="icon">
            <a href="https://github.com/AakashAhuja30/Visualizing-Tracking-Events-Data-in-Football" target="_blank" rel="noreferrer">
                <img src={github} alt="efficient"/>
            </a>
                </div>
                  
        </StyledCard>

               <motion.div variants = {lineAnimation} className="Line" ref = {element2} animate = {controls2} initial = 'hidden'></motion.div>
 
               <iframe src="https://www.youtube.com/embed/82d_eI1ZlFU" frameborder="0" 
               allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen title="football1">
               </iframe>
            </StyledMovie>

            <StyledMovie >
                <motion.h2 variants = {fadeAnimation}>Team Shape Analysis on Football Positional Data</motion.h2>
                <br></br>
                <motion.h3 variants = {fadeAnimation} style = {{color:"#353333"}}>Created using Tableau and R</motion.h3>
                <br></br>
                <StyledCard>
            <div className="icon">
            <a href="https://github.com/AakashAhuja30/Visualizing-Tracking-Events-Data-in-Football" target="_blank" rel="noreferrer">
                <img src={github} alt="efficient"/>
            </a>
                </div>
                  
        </StyledCard>

               <motion.div variants = {lineAnimation} className="Line" ref = {element3} animate = {controls3} initial = 'hidden'></motion.div>
 
                {/* <a href="https://www.youtube.com/watch?v=EOXHKfRNVxo&feature=youtu.be" target="_blank" rel="noreferrer"> */}
                {/* <motion.img variants = {photoAnimation} src={football2} alt="athlete"/> */}
                {/* </a> */}
                <iframe 
                        src="https://www.youtube.com/embed/EOXHKfRNVxo" frameborder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen title="football2">
                </iframe>
            </StyledMovie>
            
        </Styledwork>
    )


}

const Styledwork = styled(motion.div)`
min-height: 100vh;
overflow:hidden;
padding:5rem 10rem;
@media (max-width:1020px){
    padding:2rem 2rem;
}
`


const StyledMovie = styled(motion.div)`
padding-bottom:5rem;
.Line{
    height:0.3rem;
    background:#23d997;
    margin:2rem 0rem;
}
img{
    width: 100%;
    height: 80vh;
    object-fit:cover
    
    /* aspect-ratio: 4/3; */
    /* width:100%; */
    /* height:auto; */
    /* object-fit:cover;  */
}
iframe{
    width: 100%;
    height: 80vh;
}

`

const StyledFrame1 = styled(motion.div)`
position:fixed;
top:0;
left:-10;
width:100%;
height:100%;
background:#fffebf;
z-index:2;

`
const StyledFrame2 = styled(StyledFrame1)`
background: #ff8efb;

`

const StyledFrame3 = styled(StyledFrame1)`
background: #8eb2ff

`

const StyledFrame4 = styled(StyledFrame1)`
background: #8effa0

`
const StyledCard = styled.div`
margin-bottom:2rem;
.icon{
    /* align-items: center; */
    size:1px;
img{
    margin:0rem; 
    width:3%;
    height:0.1%;
}

}
`

export default OurWork;